import { render, staticRenderFns } from "./SendInvitationModal.vue?vue&type=template&id=61542958&scoped=true"
import script from "./SendInvitationModal.vue?vue&type=script&lang=js"
export * from "./SendInvitationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61542958",
  null
  
)

export default component.exports